export const BILL_PAYMENT_GROUP = 'BILL';
export const BILL_CATEGORY_TRANSLATION_PATH = 'BILL_PAYMENT.CATEGORY_NAMES';
